import CardGuides from "components/CardGuides/CardGuides";
import HeadingGuides from "components/HeadingGuides/HeadingGuides";
import { TaxonomyType } from "data/types";
import React, { useEffect, useState, useRef } from "react";
import ItemsSlider from "components/ItemsSlider";
import { guidesService } from "_services/guides.service";
import { autocompleteService } from "_services/autocomplete.service";
import { useNavigate, useLocation } from "react-router-dom";
import { useTranslation } from 'react-i18next';


interface SectionGuidesProps {
  categories?: TaxonomyType[];
  headingCenter?: boolean;
  categoryCardType?: "card1";
  className?: string;
  gridClassName?: string;
}

const SectionGuides: React.FC<SectionGuidesProps> = ({
  headingCenter = true,
  className = "",
}) => {
  const { t } = useTranslation();

  const [value, setValue] = useState("");
  const [listePays, setListePays] = useState<any[]>([]);
  const [searchResults, setSearchResults] = useState<any[]>([]);
  const [showPopover, setShowPopover] = useState(false);
  const inputRef = useRef<HTMLInputElement>(null);
  const popoverRef = useRef<HTMLDivElement>(null);

  const navigate = useNavigate();
  const location = useLocation();
  let langue="FR";
  if (location.pathname.match(/^\/en.*$/)) {
    langue="EN";
  }

  useEffect(() => {
    let langue="FR";
    if (location.pathname.match(/^\/en.*$/)) {
      langue="EN";
    }
    guidesService
      .getGuides(langue)
      .then((response) => {
        setListePays(response.data);
      })
      .catch((error) => {
        console.error("Erreur lors de la récupération des guides:", error);
      });
  }, []);

const getContinentConfig = (continent: any) => {
  const nom = (continent.nom || "").toLowerCase();
  const code = (continent.continentCode || "").toLowerCase();

  if (nom.includes("afrique") || code.includes("af")) {
    return {
      icon: "las la-paw",
      description: "Safaris, déserts, plages sauvages et cultures fascinantes.",
      iconWrapperClass:
        "bg-[#FFF1F2] border border-[#FFD6DA] shadow-[0_10px_24px_rgba(255,74,82,0.10)]",
      iconClass: "text-[#FF4A52]",
    };
  }

  if (nom.includes("amérique") || nom.includes("amerique") || code.includes("am")) {
    return {
      icon: "las la-mountain",
      description: "Des grands espaces, des villes vibrantes et des plages mythiques.",
     iconWrapperClass:
      "bg-[#FFF3E8] border border-[#FFD3A8] shadow-[0_10px_24px_rgba(249,115,22,0.14)]",
    iconClass: "text-[#F97316]",
    };
  }

  if (nom.includes("asie") || code.includes("as")) {
    return {
      icon: "las la-torii-gate",
      description: "Temples, mégalopoles, îles tropicales et traditions millénaires.",
      iconWrapperClass:
        "bg-[#F8F5FF] border border-[#E6DDFF] shadow-[0_10px_24px_rgba(124,58,237,0.10)]",
      iconClass: "text-[#7C3AED]",
    };
  }

  if (nom.includes("europe") || code.includes("eu")) {
    return {
      icon: "las la-landmark",
      description: "Capitales historiques, villages de charme et escapades culturelles.",
      iconWrapperClass:
        "bg-[#F6F7FF] border border-[#DCE3FF] shadow-[0_10px_24px_rgba(99,102,241,0.10)]",
      iconClass: "text-[#6366F1]",
    };
  }

  if (nom.includes("océanie") || nom.includes("oceanie") || code.includes("oc")) {
    return {
      icon: "las la-water",
      description: "Îles, lagons, nature spectaculaire et aventures au bout du monde.",
      iconWrapperClass:
        "bg-[#F3FAFF] border border-[#D9EEFF] shadow-[0_10px_24px_rgba(14,165,233,0.10)]",
      iconClass: "text-[#0EA5E9]",
    };
  }

  return {
    icon: "las la-globe-europe",
    description: "Découvrez les plus belles destinations pour votre prochain voyage.",
    iconWrapperClass:
      "bg-[#F8F5FF] border border-[#E6DDFF] shadow-[0_10px_24px_rgba(124,58,237,0.10)]",
    iconClass: "text-[#7C3AED]",
  };
};
  const fetchSearchResults = async () => {
    try {

      const response = await autocompleteService.getPays(value, langue);
      const data = response.data;

      if (data && data.rows) {
        const formattedResults = data.rows.map((row: any) => ({
          code_pays: row.code_pays,
          nom: row.nom,
        }));
        setSearchResults(formattedResults);
      }
    } catch (error) {
      console.error("Erreur lors de la récupération des résultats de recherche :", error);
    }
  };

  useEffect(() => {
    if (value) {
      fetchSearchResults();
    } else {
      setSearchResults([]);
    }
  }, [value]);

  const renderSearchResults = () => {
    return (
      <>
        {searchResults.map((item: any) => (
          <span
            onClick={() => handleSelectLocation(item)}
            key={item.code_pays}
            className="flex px-4 sm:px-8 items-center space-x-3 sm:space-x-4 py-4 hover:bg-neutral-100 dark:hover:bg-neutral-700 cursor-pointer"
          >
            <span className="block font-medium text-neutral-700 dark:text-neutral-200">
              {item.nom}
            </span>
          </span>
        ))}
      </>
    );
  };

  const handleSelectLocation = (item: any) => {
    navigate(`${t('lienGuide')}/${item.code_pays}`);
    setShowPopover(false);
  };

  const handleClickOutside = (event: MouseEvent) => {
    if (popoverRef.current && !popoverRef.current.contains(event.target as Node)) {
      setShowPopover(false);
    }
  };

  useEffect(() => {
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

 return (
  <div className={`nc-SectionGuides relative ${className}`}>
    <HeadingGuides desc={t("infoDestinations")} isCenter={headingCenter}>
      {t("guidesVoyage")}
    </HeadingGuides>

    <div className="relative z-20 -mt-9 px-4">
      <div className="mx-auto max-w-2xl">
        <div
          className="
            relative
            flex
            items-center
            rounded-full
            bg-white
            px-5
            py-3
            shadow-[0_18px_45px_rgba(15,23,42,0.12)]
            ring-1
            ring-slate-900/5
            dark:bg-slate-900
            dark:ring-white/10
          "
        >
          <i className="las la-search text-2xl text-slate-950 dark:text-white" />

          <input
            type="text"
            className="
              ml-3
              h-10
              flex-1
              border-0
              bg-transparent
              text-sm
              font-semibold
              text-slate-900
              outline-none
              placeholder:text-slate-400
              focus:ring-0
              dark:text-white
            "
            maxLength={30}
            placeholder={t("chercherDestination")}
            value={value}
            onChange={(e) => setValue(e.currentTarget.value)}
            onClick={() => setShowPopover(true)}
            ref={inputRef}
          />

          {showPopover && value && (
            <div
              ref={popoverRef}
              className="
                absolute
                left-0
                right-0
                top-full
                z-40
                mt-3
                overflow-hidden
                rounded-3xl
                bg-white
                py-3
                shadow-2xl
                ring-1
                ring-slate-900/5
                dark:bg-neutral-800
              "
            >
              {renderSearchResults()}
            </div>
          )}
        </div>
      </div>
    </div>

    
    <div className="mt-10 space-y-12 px-4">
    {listePays.map((continent, index) => {
  const continentConfig = getContinentConfig(continent);

  return (
    <section key={index} className="relative">
      <div className="mb-5 flex items-end justify-between gap-4">
        <div className="flex items-center gap-3">
          <div
  className={`
    flex
    h-12
    w-12
    items-center
    justify-center
    rounded-2xl
    backdrop-blur-sm
    ring-1
    ring-white/70
    ${continentConfig.iconWrapperClass}
  `}
>
  <i className={`${continentConfig.icon} ${continentConfig.iconClass} text-[22px]`} />
</div>
          <div>
            <h1 className="text-2xl font-black text-slate-950 dark:text-white">
              {continent.nom}
            </h1>

            <p className="mt-1 text-sm font-semibold text-slate-500">
              {continentConfig.description}
            </p>
          </div>
        </div>

          </div>

          <ItemsSlider title={continent.continentCode} barreHaute={false}>
            {continent.pays.map((item: any, i: any) => (
              <CardGuides key={`${continent.code}-${i}`} taxonomy={item} />
            ))}
          </ItemsSlider>
        </section>
      )})}
    </div>
  </div>
);
};

export default SectionGuides;
